<template>
  <section class="list-content">
    <div class="list-content-itens">
      <Breadcrumb :links="links" />
      <div class="list-content-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3">
            <router-link
              tag="a"
              :to="{ name: 'RegisterContentSpecialty' }"
              class="content--card-register"
              style="min-height: 200px"
            >
              <img
                class="img-fluid"
                src="@/assets/img/image-plus.png"
                alt="image plus"
                title="image plus"
              />
            </router-link>
          </div>
          <template v-if="hasContentPages">
            <div
              class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3"
              v-for="contentPage in contentPages.data"
              :key="contentPage.id"
            >
              <CardContentPages :content-page="contentPage" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Breadcrumb from "@/components/breadcrumb/Index";
import CardContentPages from "@/views/Content/components/CardContentPages";

export default {
  data() {
    return {
      links: [
        {
          name: "Conteúdos das páginas",
          routerName: "ContentPages",
        },
        {
          name: "Listar Conteúdo Especialidades",
          routerName: "ListContentSpecialties",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      contentPages: "ContentPages/contentPages",
    }),
    hasContentPages() {
      return (
        this.contentPages &&
        Array.isArray(this.contentPages?.data) &&
        this.contentPages.data.length > 0
      );
    },
  },
  components: {
    Breadcrumb,
    CardContentPages,
  },
  methods: {
    ...mapActions("ContentPages", ["consultContentPages"]),
  },
  mounted() {
    this.consultContentPages();
  },
};
</script>
